<script>
export default {
  locales: {
    pt: {
      'My Investment': 'Meu Investimento',
      'My Profit': 'Meu Rendimento',
      'My Team': 'Minha Equipe',
      'Activation': 'Ativação',
      'Total Bonus': 'Total de Bônus',
      'Current Balance': 'Saldo Atual',
      'Graduation': 'Graduação',
      'No Graduation': 'Sem Graduação',
      'Points': 'Pontos',
      'ACTIVE': 'ATIVO',
      'INACTIVE': 'INATIVO',
      'PENDING': 'PENDENTE',
      'QUALIFIED': 'QUALIFICADO',
      'NOT QUALIFIED': 'NÃO QUALIFICADO',
      'Status': 'Status',
      'Left Side': 'Lado Esquerdo',
      'Right Side': 'Lado Direito',
      'COEFFICIENT': 'COEFICIENTE',
      'Bonus': 'Bônus',
    },
    es: {
      'My Investment': 'Mi Inversión',
      'My Profit': 'Mi Rendimiento',
      'My Team': 'Mi Equipo',
      'Activation': 'Activación',
      'Total Bonus': 'Bono Total',
      'Current Balance': 'Saldo Actual',
      'Graduation': 'Graduación',
      'No Graduation': 'Sin Graduación',
      'Points': 'Puntos',
      'ACTIVE': 'ACTIVO',
      'INACTIVE': 'INACTIVO',
      'PENDING': 'PENDIENTE',
      'QUALIFIED': 'CALIFICADO',
      'NOT QUALIFIED': 'NO CALIFICADO',
      'Status': 'Estado',
      'Left Side': 'Lado Izquierdo',
      'Right Side': 'Lado Derecho',
      'COEFFICIENT': 'COEFICIENTE',
      'Bonus': 'Bono',
    }
  },
  props: {
    type: {
      type: String,
      default: "default"
    },
    title: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: ""
    },
    month: {
      type: Boolean,
      default: false
    },
    date: {
      type: String,
      default: ""
    },
    period: {
      type: String,
      default: ""
    },
    extra: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
    }
  },
  computed: {
    // gera uma cor de degradê consistente para o mesmo icone, variando entre os icones exibidos
    gradientClass() {
      const gradients = ['grad-1', 'grad-2', 'grad-3', 'grad-4', 'grad-5'];
      let hash = 0;
      for (let i = 0; i < this.icon.length; i++) {
        hash = (hash + this.icon.charCodeAt(i)) % gradients.length;
      }
      return gradients[hash];
    },
    // no value do type square, a primeira palavra mantem o tamanho normal e o restante fica menor
    squareValueHtml() {
      return this.t(this.value);
    }
  }
};
</script>

<template>
  <div class="card bg-white stat-tile">
    <div class="card-body p-3 pr-4">
      <div v-if="type == 'line'" class="d-flex align-items-center">
        <div>
          <div class="stat-icon" :class="gradientClass">
            <i class="bx font-size-22 text-white align-middle" :class="icon"></i>
          </div>
        </div>
        <div class="flex-fill ml-2">
          <h6 v-if="value == 'active'" class="mb-0 notranslate font-weight-medium"><span class="stat-badge-success">{{ t('ACTIVE') }}</span></h6>
          <h6 v-else-if="value == 'inactive'" class="mb-0 notranslate font-weight-medium"><span class="stat-badge-danger">{{ t('INACTIVE') }}</span></h6>
          <h6 v-else-if="value == 'qualified'" class="mb-0 notranslate font-weight-medium font-size-14"><span class="stat-badge-success">{{ t('QUALIFIED') }}</span></h6>
          <h6 v-else-if="value == 'not_qualified'" class="mb-0 notranslate font-weight-medium font-size-14"><span class="stat-badge-danger">{{ t('NOT QUALIFIED') }}</span></h6>
          <h5 v-else class="mb-0 notranslate font-weight-medium text-uppercase" v-html="t(value)"></h5>
          <p class="font-weight-medium mb-0 text-uppercase font-weight-light font-size-12" v-html="t(title)"></p>
        </div>
        <div v-if="month" class="text-right">
          <div class="font-size-11 bg-soft-light rounded p-1">
            {{ this.$moment().format('MM/YYYY') }}
          </div>
        </div>
        <div v-if="extra" class="text-right">
          <div class="font-size-11 bg-soft-light rounded p-1">
            {{ extra }}
          </div>
        </div>
      </div>
      <div v-else-if="type == 'center'" class="text-center align-items-center">
        <h5 v-if="value == 'active'" class="mb-0 notranslate font-weight-medium"><span class="stat-badge-success">{{ t('ACTIVE') }}</span></h5>
        <h5 v-else-if="value == 'inactive'" class="mb-0 notranslate font-weight-medium"><span class="stat-badge-danger">{{ t('INACTIVE') }}</span></h5>
        <h5 v-else-if="value == 'qualified'" class="mb-0 notranslate font-weight-medium font-size-14"><span class="stat-badge-success">{{ t('QUALIFIED') }}</span></h5>
        <h5 v-else-if="value == 'not_qualified'" class="mb-0 notranslate font-weight-medium font-size-14"><span class="stat-badge-danger">{{ t('NOT QUALIFIED') }}</span></h5>
        <h5 v-else class="mb-0 notranslate font-weight-medium text-uppercase">{{ t(value) }}</h5>
        <p class="font-weight-medium mb-0 text-uppercase font-weight-light" v-html="t(title)"></p>
      </div>
      <div v-else-if="type == 'square'" class="text-left">
        <div class="d-flex justify-content-between">
          <div class="stat-icon mb-2" :class="gradientClass">
            <i class="bx font-size-22 text-white align-middle" :class="icon"></i>
          </div>
          <div v-if="month">
            <div class="font-size-11 bg-soft-light rounded p-1">
              {{ this.$moment().format('MM/YYYY') }}
            </div>
          </div>
          <div v-if="extra">
            <div class="font-size-11 bg-soft-light rounded p-1">
              {{ extra }}
            </div>
          </div>
        </div>
        <h5 v-if="value == 'active'" class="mb-1 notranslate font-weight-medium"><span class="stat-badge-success">{{ t('ACTIVE') }}</span></h5>
        <h5 v-else-if="value == 'inactive'" class="mb-1 notranslate font-weight-medium"><span class="stat-badge-danger">{{ t('INACTIVE') }}</span></h5>
        <h5 v-else-if="value == 'qualified'" class="mb-1 notranslate font-weight-medium font-size-14"><span class="stat-badge-success">{{ t('QUALIFIED') }}</span></h5>
        <h5 v-else-if="value == 'not_qualified'" class="mb-1 notranslate font-weight-medium font-size-14"><span class="stat-badge-danger">{{ t('NOT QUALIFIED') }}</span></h5>
        <h5 v-else class="mb-1 notranslate font-weight-medium text-uppercase" v-html="squareValueHtml"></h5>
        <p class="font-weight-medium mb-0 text-uppercase font-weight-light font-size-11" v-html="t(title)"></p>
      </div>
      <div v-else class="d-flex justify-content-between align-items-center">
        <p class="font-weight-medium mb-0 text-uppercase font-weight-light" v-html="t(title)"></p>
        <h5 v-if="value == 'active'" class="mb-0 notranslate font-weight-medium"><span class="stat-badge-success">{{ t('ACTIVE') }}</span></h5>
        <h5 v-else-if="value == 'inactive'" class="mb-0 notranslate font-weight-medium"><span class="stat-badge-danger">{{ t('INACTIVE') }}</span></h5>
        <h5 v-else-if="value == 'qualified'" class="mb-0 notranslate font-weight-medium font-size-14"><span class="stat-badge-success">{{ t('QUALIFIED') }}</span></h5>
        <h5 v-else-if="value == 'not_qualified'" class="mb-0 notranslate font-weight-medium font-size-14"><span class="stat-badge-danger">{{ t('NOT QUALIFIED') }}</span></h5>
        <h5 v-else-if="value == 'plan_chosen'" class="mb-0 notranslate font-weight-medium"><span class="bg-danger rounded text-white px-2">{{ t('PENDING') }}</span></h5>
        <h5 v-else class="mb-0 notranslate font-weight-medium text-uppercase">{{ t(value) }}</h5>
      </div>
    </div>
  </div>
</template>

<style>
.stat-tile h5,
.stat-tile h6 {
  letter-spacing: -.01em;
}

.stat-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  color: #fff;
  border-radius: .875rem;
  background: linear-gradient(
    145deg,
    #3b6cff,
    #2c00f5
  );

  box-shadow:
    0 5px 12px rgba(30, 90, 240, 0.25),
    inset 1px 1px 1px rgba(255, 255, 255, 0.45);
}

.stat-icon::after {
  content: "";
  position: absolute;
  top: 1px;
  left: 2px;
  right: 2px;
  height: 45%;

  border-radius: 10px 10px 50% 50%;

  background: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0.22),
      transparent
  );

  pointer-events: none;
}

.stat-badge-success,
.stat-badge-danger {
  display: inline-block;
  padding: 0 .5rem;
  border-radius: .25rem;
  color: #fff;
}

.stat-badge-success {
  background: linear-gradient(135deg, #67d583, #279543);
  box-shadow: 0 4px 10px -3px rgba(39, 149, 67, .5);
}

.stat-badge-danger {
  background: linear-gradient(135deg, #ff6c64, #bf2c24);
  box-shadow: 0 4px 10px -3px rgba(191, 44, 36, .5);
}

.stat-value-secondary {
  font-size: 11px !important;
}
</style>